module.exports = __webpack_public_path__ + "static/media/Machine Drawing.a53f48c7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Machine Drawing.pdf
// module id = 140
// module chunks = 0